import { EyeInvisibleOutlined, EyeOutlined } from '@ant-design/icons';
import { Col, ConfigProvider, Divider, Row, Table } from 'antd';
import classNames from 'classnames/bind';
import moment from 'moment';
import { useEffect, useState } from 'react';
import offerAPI from '~/api/OfferAPI';
import { SVGS } from '~/assets/assetsPath';
import EmptyForm from '~/components/Empty';
import Wallet from '~/components/Wallet';
import { getNumberWithCommas } from '~/utils';
import CardAboutMe from '../../components/card-about-me';
import styles from './HistoryWithdraw.module.scss';
import styled from 'styled-components';
import { logEvent } from 'firebase/analytics';
import { analytics } from '~/service/firebase';
import { LeftOutlined } from '@ant-design/icons';
import config from '~/config';
import { useNavigate } from 'react-router-dom';

const cx = classNames.bind(styles);

const TableCustom = styled.div`
    width: 100%;
    .ant-table-body {
        &::-webkit-scrollbar {
            width: 4px;
            height: 4px;
        }
        /* Track */
        &::-webkit-scrollbar-track {
            box-shadow: inset 0 0 5px grey;
            border-radius: 10px;
        }
        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: var(--main-color);
            border-radius: 10px;
        }
        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            // background: var(--main-color-hover);
        }
    }
    @media screen and (max-width: 480px) {
        display: none;
    }
`;

const HistoryWithdraw = () => {
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [showAmount, setShowAmount] = useState(false);
    const [historyWithdraw, setHistoryWithdraw] = useState([]);

    const columnsWithdraw = [
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Transaction</div>;
            },
            width: '30%',
            render: (item, record) => (
                <div
                    style={{
                        fontWeight: '600',
                    }}
                >
                    Withdraw money to bank {record?.bank_type}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Time</div>;
            },
            dataIndex: 'created_at_unix_timestamp',
            align: 'center',
            width: '20%',
            render: (item) => (
                <div
                    style={{
                        color: 'rgba(137, 137, 137, 1)',
                    }}
                >
                    {moment(item, 'x').format('HH:mm, DD/MM/YYYY')}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Amount</div>;
            },
            // dataIndex: 'change_amount',
            dataIndex: 'original_value',
            align: 'center',
            width: '20%',
            render: (item, record) => (
                <div
                    style={{
                        fontWeight: '600',
                        color: '#311d4f',
                    }}
                >
                    {' '}
                    {showAmount ? `${getNumberWithCommas(item)} d` : '************'}
                    {/* {showAmount
                        ? `${
                              record.type === 'REQUEST_WITHDRAW' && record.status_enum === 'DONE' ? '+' : ''
                          } ${getNumberWithCommas(item)} d`
                        : '**********'} */}
                </div>
            ),
        },
        {
            title: () => {
                return <div style={{ fontSize: '16px', fontWeight: '600', color: '#311d4f' }}>Status</div>;
            },
            dataIndex: 'status_enum',
            width: '20%',
            align: 'center',
            render: (item) => (
                <>
                    {item === 'PENDING' && (
                        <div
                            style={{
                                fontWeight: '600',
                                color: 'rgba(76, 111, 237, 1)',
                            }}
                        >
                            Processing
                        </div>
                    )}
                    {item === 'DONE' && (
                        <div
                            style={{
                                fontWeight: '600',
                                color: 'rgba(67, 181, 160, 1)',
                            }}
                        >
                            Success
                        </div>
                    )}
                    {item === 'CANCEL' && (
                        <div
                            style={{
                                fontWeight: '600',
                                color: 'rgba(234, 56, 56, 1)',
                            }}
                        >
                            Denied
                        </div>
                    )}
                </>
            ),
        },
    ];

    const [pagination, setPagination] = useState({
        page: 1,
        limit: 10,
        total_item: 0,
        total_page: 0,
        count_pending: 0,
        count_done: 0,
        count_cancel: 0,
    });

    const handleGetHistoryWithdraw = async (list, page, activeKey) => {
        try {
            setIsLoading(true);
            let historyWithdraws = list;
            let final = [];
            let filter = `{"type":"REQUEST_WITHDRAW"}`;

            const params = {
                fields: '["$all"]',
                filter: filter,
                order: '[["created_at", "DESC"]]',
                limit: pagination.limit,
                page: page,
            };
            const res = await offerAPI.getHistoryWithdrawAPI(params);

            if (res.code === 200) {
                historyWithdraws.push(...res.results.object.rows);
                setPagination({
                    ...pagination,
                    page: page,
                    total_item: res.results.object.count,
                    total_page: Math.ceil(res.results.object.count / pagination.limit),
                    count_pending: res.results.object.count_pending,
                    count_done: res.results.object.count_done,
                    count_cancel: res.results.object.count_cancel,
                });
            }
            if (historyWithdraws?.length) {
                final = [...new Map(historyWithdraws.map((item) => [item['id'], item])).values()];
            }

            setHistoryWithdraw(final);
            setIsLoading(false);
        } catch (err) {
            console.log(err);
        }
    };

    const handleSeeMore = () => {
        try {
            const nextPage = pagination.page + 1;
            handleGetHistoryWithdraw(historyWithdraw, nextPage);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        handleGetHistoryWithdraw(historyWithdraw, pagination.page);
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        logEvent(analytics, 'VBeauty_Web_TrangLichSuRutTien');
        // eslint-disable-next-line
    }, []);

    return (
        <div className={cx('wrapper')}>
            <div className={cx('container')}>
                <div className={cx('left_section')}>
                    <div className={cx('left_wrapper')}>
                        <div className={cx('left_container')}>
                            <Row>
                                <CardAboutMe tabIndex={{ parent: 1, children: 3 }} />
                            </Row>
                        </div>
                    </div>
                </div>
                <div className={cx('title_header')}>
                    <Row className={cx('title_header_row')}>
                        <p className={cx('title')}>
                            <LeftOutlined
                                onClick={() => navigate(config.routes.personalPage)}
                                className={cx('btn_back')}
                            />{' '}
                            Withdrawal history
                        </p>
                        <div className={cx('payment')} onClick={() => navigate(config.routes.withdraw)}>
                            <img src={SVGS.IconMoneyReceiveBlack} alt="icon-dollar" />
                            <p>Withdraw money</p>
                        </div>
                    </Row>
                </div>
                <div className={cx('right_section')}>
                    <Row className={cx('name_page')}>
                        <Col xs={14}>Withdrawal history</Col>
                        <Col xs={10}>
                            <Row justify="end">
                                {showAmount ? (
                                    <EyeOutlined
                                        className={cx('icon_show_amount')}
                                        onClick={() => setShowAmount(false)}
                                    />
                                ) : (
                                    <EyeInvisibleOutlined
                                        className={cx('icon_show_amount')}
                                        onClick={() => setShowAmount(true)}
                                    />
                                )}
                            </Row>
                        </Col>
                    </Row>
                    <div className={cx('right_container')}>
                        <div className={cx('wallet')}>
                            <Wallet showAmount={showAmount}></Wallet>
                            <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                        </div>
                        <Row className={cx('status_container')}>
                            <Col xs={8}>
                                <Row>
                                    <div className={cx('tab_status', 'tab_process')}>
                                        <img src={SVGS.IconProcessTopUp} alt="" />
                                        <div className={cx('name_status')}>Processing</div>
                                        <div className={cx('amount_status')}>{pagination.count_pending}</div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={8}>
                                <Row>
                                    <div className={cx('tab_status', 'tab_success')}>
                                        <img src={SVGS.IconSuccessTopUp} alt="" />
                                        <div className={cx('name_status')}>Success</div>
                                        <div className={cx('amount_status')}>{pagination.count_done}</div>
                                    </div>
                                </Row>
                            </Col>
                            <Col xs={8}>
                                <Row>
                                    <div className={cx('tab_status', 'tab_reject')}>
                                        <img src={SVGS.IconRejectTopUp} alt="" />
                                        <div className={cx('name_status')}>Reject</div>
                                        <div className={cx('amount_status')}>{pagination.count_cancel}</div>
                                    </div>
                                </Row>
                            </Col>
                        </Row>
                        <Divider style={{ borderTop: '5px solid rgba(0,0,0,.06)' }} />
                        <div className={cx('table_container')}>
                            <Content isLoading={isLoading} columns={columnsWithdraw} history={historyWithdraw} />
                            {pagination.page < pagination.total_page && (
                                <Row justify="center" style={{ marginTop: '30px' }}>
                                    <div className={cx('btn_see_more')} onClick={handleSeeMore}>
                                        see more
                                    </div>
                                </Row>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

const Content = ({ isLoading, columns, history }) => {
    return (
        <div>
            {/* <Divider style={{ borderTop: '10px solid rgba(0,0,0,.06)' }} /> */}
            <Row justify="center">
                <ConfigProvider renderEmpty={() => <EmptyForm />}>
                    <TableCustom>
                        <Table
                            className={cx('table')}
                            columns={columns}
                            dataSource={history}
                            pagination={false}
                            loading={isLoading}
                            scroll={{ y: 700 }}
                        />
                    </TableCustom>
                </ConfigProvider>{' '}
                <div className={cx('mobile_view')}>
                    {history?.length ? (
                        <>
                            {history?.map((item) => {
                                return (
                                    <Row className={cx('record_mobile')}>
                                        <Col xs={16}>
                                            <Row className={cx('title')}>
                                                Withdraw money to bank {item?.bank_type}
                                            </Row>
                                            <Row className={cx('time')}>
                                                {moment(item?.created_at_unix_timestamp, 'x').format(
                                                    'HH:mm, DD/MM/YYYY',
                                                )}
                                            </Row>
                                        </Col>
                                        <Col xs={8}>
                                            <Row
                                                justify="end"
                                                style={{
                                                    fontWeight: '500',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                {item?.status_enum === 'PENDING' && (
                                                    <div
                                                        style={{
                                                            color: 'rgba(76, 111, 237, 1)',
                                                        }}
                                                    >
                                                        Processing
                                                    </div>
                                                )}
                                                {item?.status_enum === 'DONE' && (
                                                    <div
                                                        style={{
                                                            color: 'rgba(67, 181, 160, 1)',
                                                        }}
                                                    >
                                                        Success
                                                    </div>
                                                )}
                                                {item?.status_enum === 'CANCEL' && (
                                                    <div
                                                        style={{
                                                            color: 'rgba(234, 56, 56, 1)',
                                                        }}
                                                    >
                                                        Denied
                                                    </div>
                                                )}
                                            </Row>
                                            <Row className={cx('value')} justify="end">
                                                {getNumberWithCommas(item?.original_value || 0)} d
                                            </Row>
                                        </Col>
                                    </Row>
                                );
                            })}
                        </>
                    ) : (
                        <Row justify="center">
                            <div className={cx('no_service')}>
                                <img src={SVGS.IconNoService} alt="" />
                                <span>No transactions</span>
                            </div>
                        </Row>
                    )}
                </div>
            </Row>
        </div>
    );
};

export default HistoryWithdraw;
